import React,{useEffect} from "react";
import { useParams } from "react-router-dom";
import CandidateSingleEditView from "../../components/CandidateSingleEditView";
import Dashboard from "../../layouts/Dashboard";
import isConsultant from "../../services/isConsultant";


function ApplicationList() {
  // Uncommon Hooks
  const { id } = useParams();

  return (
    <div>
    {!isConsultant() && <Dashboard title="Candidate Edit Responses">
      <CandidateSingleEditView id={id} />
    </Dashboard>}
    </div>
  );
}

export default ApplicationList;
